import { UserModel } from '@app/models/UserModel';

export interface FeatureRequest {
  id: number;
  created_by: UserModel;
  user_vote: string;
  description: string;
  total_upvote: number;
  total_downvote: number;
  total_comments: number;
  category: number;
  is_pinned: boolean;
  created_at: string;
  updated_at: string;
  brand: string;
  /** Posted from the admin panel on behalf of support -> verified badge. */
  is_team: boolean;
}

export interface FeatureComment {
  id: number;
  comment: string;
  created_by: UserModel;
  feature: number;
  total_likes: number;
  is_team: boolean;
  user_has_liked: boolean;
  created_time: string;
  updated_time: string;
}

/** Brand is a comma-separated list; "ease,wavon" targets both feeds. */
export const brandList = (brand: string): string[] =>
  (brand || '').split(',').map((b) => b.trim().toLowerCase()).filter(Boolean);

export const brandLabel = (brand: string): string => {
  const parts = brandList(brand);
  if (parts.length > 1) return 'Both';
  if (parts[0] === 'wavon') return 'Wavon';
  if (parts[0] === 'ease') return 'Ease';
  return brand || '—';
};
